<script setup lang="ts">
import { inject } from 'vue'
import { Field } from 'vee-validate'
import type { FormSettings } from '@/components/interfaces/project-settings-view.interfaces'
import { getVisualPositionTypes } from '@/config/config.ts'
import { ProjectSettingsField, ProvideElement } from '@/enums.ts'
import CrdRange from '../../../common/CrdRange.vue'
import { useTranslations } from '@/composables/useTranslations.ts'

const { t } = useTranslations()
const { widgetVisual } = inject(ProvideElement.ProjectSettingsFormSettings) as FormSettings
</script>
<template>
  <div class="margin-selector flex items-center overflow-x-auto flex-wrap gap-8 max-w-full flex-col p-2">
    <div class="flex gap-4 w-full flex-col">
      <div class="flex-1">
        <CrdRange
          :label="t('settings.primary.horizontalIndentation')"
          :description="t('settings.primary.theHorizontalIndentationOfTheWidget')"
          :name="ProjectSettingsField.WidgetVisualHorizontalPx"
          :min="widgetVisual.margins.horizontalPx.min"
          :max="widgetVisual.margins.horizontalPx.max"
          :step="widgetVisual.margins.horizontalPx.step"
          unit="px"
        />
      </div>
      <div class="flex-1">
        <CrdRange
          :label="t('settings.primary.verticalIndentation')"
          :description="t('settings.primary.theVerticalIndentationOfTheWidget')"
          :name="ProjectSettingsField.WidgetVisualVerticalPx"
          :min="widgetVisual.margins.verticalPx.min"
          :max="widgetVisual.margins.verticalPx.max"
          :step="widgetVisual.margins.verticalPx.step"
          unit="px"
        />
      </div>
    </div>
    <div class="flex gap-4">
      <label
        class="flex items-center gap-2"
        v-for="type in getVisualPositionTypes()"
        :key="type.id"
        :value="type.title"
        :aria-label="type.title"
      >
        <Field
          type="radio"
          name="widgetVisual.margins.position"
          :value="type.id"
          class="text-indigo-400 focus:ring-indigo-500"
        />
        <span class="text-sm text-gray-700">{{ type.title }}</span>
      </label>
    </div>
  </div>
</template>

<style scoped>
@reference "../../../../index.css";

.margin-selector {
  @apply flex items-center overflow-x-auto flex-wrap gap-8 max-w-full flex-col p-2;
}
</style>
